module.exports = __webpack_public_path__ + "static/media/0_2019_05_26.ac4b50c4.jpg";